import { betaGraphqlSchemaUri } from '@velasca/constants'

/**
 * If the current URL includes the string 'localhost', then return the beta Shopify store's GraphQL endpoint, otherwise return the current store's GraphQL endpoint.
 *
 * @param location - The current URL.
 */
export const getGraphqlSchemaURI = (
  location: string,
  isWoman: boolean,
): string => {
  const manUri = location.includes('localhost')
    ? betaGraphqlSchemaUri
    : `${location}/api/2024-07/graphql.json`
  const womanUri = location.includes('localhost')
    ? 'https://velasca-woman-beta.myshopify.com/api/2024-07/graphql.json'
    : `${location}/api/2024-07/graphql.json`

  const uri = isWoman ? womanUri : manUri

  return uri
}
